import Vue from 'vue'
import VueI18n from 'vue-i18n'
import cookies from 'vue-cookies'
// 语言包
import cn from './cn.js'
import hk from './hk.js'
// import en from './en.js'

export const list=[
  {id:0,lang:'cn',name:'简体中文'},
  {id:1,lang:'hk',name:'繁體中文'},
  // {id:2,lang:'en',name:'English'},
]
const defaultId=1 //默认语言

let locale='hk'
let LanguageType=cookies.get('LanguageType')
if(LanguageType){
  let active=list[Number(LanguageType)]
  if(active) locale=active.lang
  else{
    cookies.set('LanguageType',defaultId, '2y')
  }
}else{
  cookies.set('LanguageType',defaultId, '2y')
}

Vue.use(VueI18n);
const i18n=new VueI18n({
  locale,
  messages: {cn,hk}
})
export default i18n;

export const getName=lang=>{
  let arr=list.filter(v=>v.lang==lang);
  return arr.length?arr[0].name:'';
}

// 获取当前的语言表，供非vue组件使用
export const getMessage=()=>{
  return i18n.messages[i18n.locale]
}

export const t=(key)=>{
  let m=getMessage();
  let v=key
  key=key.split('.')
  try{
    v=m[key[0]][key[1]]
  }catch(e){}
  return v;
}